<template>
    <b-modal :no-close-on-backdrop="true"
        @hidden="resetData"
        id="modal-Create"
        :title="title" 
        hide-footer 
        :centered="true"
        header-class="px-4"
        body-class="px-0 modal-content-edit-budget"
        v-model="open">
        <div :class="`${innerHeight < 969 ? 'max-height-content' : ''}`">
            <div class="px-4">
                <b-row>
                    <b-col cols="12" class="mb-16">
                        <gofix-form-dropdown
                            label="FM Code"
                            vLabel="fm_code"
                            :filterable="false"
                            required
                            :options="fmCodes"
                            v-model="data.fm_code"
                            @search="searchFmCode">
                            <template slot="gofixInput:dropdown:option" slot-scope="option">
                                <div class="maintOption">
                                    <p class="mb-0">{{ option.fm_code }}</p>
                                    <span class="text-hidden-ellipsis-two-row w-100" style="font-size: 12px; color: #ccc; white-space: normal;">{{ option.description || '-' }}</span>
                                </div>
                            </template>
                        </gofix-form-dropdown>
                    </b-col>
                    <b-col cols="12" class="mb-16 box-form-input">
                        <gofix-form-input label="Description" v-model="data.description"></gofix-form-input>
                    </b-col>
                    <b-col cols="12" class="mb-16 box-form-input" v-if="!isNew && data.entry_type == 'Revision'">
                        <gofix-form-dropdown
                            label="Status"
                            vLabel="label"
                            required
                            :reduce="option => option.value"
                            :options="optionStatus"
                            v-model="data.status">
                        </gofix-form-dropdown>
                    </b-col>
                </b-row>
                <b-row class="align-items-end box-form-input">
                    <b-col style="flex-grow: 4;">
                        <gofix-form-input-number
                            label="Yearly Budget Allocation"
                            v-model="yearly_budget_allocation"
                            desc=" "
                            prefix="$">
                        </gofix-form-input-number>
                    </b-col>
                    <b-col>
                        <gofix-button class="mb-9" label="DIVIDE EQUALLY" @click="handleDivide" outline></gofix-button>
                    </b-col>
                </b-row>
            </div>
            <hr class="w-100"/>
            <div class="px-4">
                <b-row class="box-form-input">
                    <template v-for="(item, index) in data.budgets">
                        <b-col md="4" class="mb-35" :key="index">
                            <gofix-form-input-number
                                :label="item.label"
                                v-model="item.value"
                                desc=" "
                                prefix="$"
                                @input="reComputed">
                            </gofix-form-input-number>
                        </b-col>
                    </template>
                </b-row>
            </div>
        </div>
        <b-row class="content-total mx-0 mb-20" no-gutters>
            <b-col md="4" class="pl-4">
                <span>Total {{ titleTotal }}</span>
            </b-col>
            <b-col md="8" class="text-right pr-4">
                <span>{{ data.total | formatMoney }}</span>
            </b-col>
        </b-row>
        <b-button-group class="d-block text-right pr-12">
            <gofix-button label="SUBMIT" @click="saveData" :loading="loading" noBorder></gofix-button>
        </b-button-group>
    </b-modal>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    const accounting = require('accounting');
    export default {
        name: 'modal-edit-budget-detail',
        props: {
            value: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: ''
            },
            titleTotal: {
                type: String,
                default: ''
            },
            item: {
                type: Object,
                default: () => {}
            },
            contract_id: {
                type: Number,
                default: null
            },
            isNew: {
                type: Boolean,
                default: false
            },
            glAccountGroup: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                open: false,
                loading: false,
                contracts: [],
                fmCodes: [],
                timer: {
                    store: null,
                    contract: null,
                    fmCode: null
                },
                yearly_budget_allocation: null,
                optionStatus: [
                    {
                        label: 'Rev-Draft',
                        value: 'rev-draft'
                    },
                    {
                        label: 'Rev',
                        value: 'rev'
                    }
                ],
                data: {
                    status: 'rev-draft',
                    budgets: [],
                    fm_code: null,
                    total: 0
                },
                innerHeight: 969
            }
        },
        computed: {
            ...mapGetters({
                HeaderItem: 'BudgetAllocationController/headerItem',
            }),
        },
        created() {
            this.innerHeight = window.innerHeight
        },
        watch: {
            value: function(val) {
                if(val) {
                    if(!this.item.budgets) {
                        this.data = {
                            status: 'rev-draft',
                            budgets: [],
                            fm_code: null,
                            total: 0
                        };
                        this.data.financial_year_start = this.item.financial_year_start;
                        this.yearly_budget_allocation  = null;                        
                        this.settArrayBudget();
                    } else {
                        this.data = Object.assign(this.data, this.item);
                        this.data.fm_code = {
                            id: this.data.fm_code_id,
                            fm_code: this.data.fm_code
                        }
                        let total = 0;
                        this.data.budgets.map(item => {
                            total += accounting.unformat(item.value)
                        })
                        this.data.total = total;
                        this.yearly_budget_allocation = accounting.formatMoney(total);
                    }

                    if(this.contract_id) {
                        this.getFmCode();
                    }
                }
                this.open = val;
            },
            open: function(val) {
                this.$emit('input', val);
            },
            "data.fm_code": function(val, old) {
                if((!this.data. budget_header_id && val) || (old && old.id && val && val.id && val.id != old.id))
                    this.data.description = val && val.description ? val.description : null
            }
        },
        methods: {
            saveData() {
                if (this.timer.store) {
                    clearTimeout(this.timer.store);
                    this.timer.store = null;
                }
                this.timer.store = setTimeout(() => {
                    if(!this.data.fm_code) {
                        return this.$alertNotification("FM Code is required", "danger");
                    }
                    if(!this.isNew && this.data.entry_type == 'Revision' && !this.data.status) {
                        return this.$alertNotification("Status is required", "danger");
                    }
                    if(this.loading) return;
                    this.loading = true;
                    let request = {
                        budget_header_id : this.HeaderItem.id,
                        fm_code_id: this.data.fm_code.id,
                        description: this.data.description,
                        month_year: JSON.parse(JSON.stringify(this.data.budgets)),
                        entry_type: this.HeaderItem.status == 'Draft' ? 'Planned' : 'Revision',
                        status: this.data.status
                    }
                    request.month_year.map(item => {
                        item.value = accounting.unformat(item.value);
                        return item;
                    })
                    request.month_year = JSON.stringify(request.month_year);
                    let api = 'addBudgetEntries';
                    if(!this.isNew) {
                        request.display_line_number = this.data.display_line_number
                        request.get_fm_code_id = this.item.fm_code_id
                        api = 'updateBudgetEntries';
                    }
                        
                    this.$store.dispatch(`BudgetAllocationController/${api}`, request)
                    .then(response => {
                        this.loading = false;
                        this.open = false;
                        this.$alertNotification(this.$notificationV2(this.isNew ? 'adding' : 'editing', 'budget_entries'));
                        this.$emit('storeSuccess');
                     })
                    .catch(err => {
                        if(err.response && err.response.data.error && err.response.data.error.message && err.response.data.error.message.error)
                            this.$alertNotification(err.response.data.error.message.error, "danger");
                        this.loading = false;
                    })
                }, 300);
                this.$emit('save', this.data);
            },
            handleDivide() {
                if(!this.yearly_budget_allocation) {
                    return this.$alertNotification("Please enter the yearly budget allocation", "danger");
                }
                
                let budget = accounting.unformat(this.yearly_budget_allocation);
                let beDivided = (budget / 12);
                this.data.budgets.map(item => {
                    item.value = accounting.formatMoney(beDivided);
                    return item;
                })

                this.data.total = budget;
            },
            reComputed() {
                let total = 0;
                this.data.budgets.map(item => {
                    total += accounting.unformat(item.value);
                })
                this.data.total = total;
            },
            resetData() {
                this.data.client_contract_id   = null;
                this.data.financial_year_start = null;
            },
            settArrayBudget() {
                if(this.data.financial_year_start) {
                    var dateStart = moment(this.data.financial_year_start);
                    var dateEnd = moment(this.data.financial_year_start).add(11, 'M');
                    var timeValues = [];

                    while (dateEnd > dateStart || dateStart.format('M') === dateEnd.format('M')) {
                        timeValues.push({
                            key: dateStart.format('YYYY-MM-DD'),
                            label: dateStart.format('MMM, YYYY'),
                            value: ''
                        });
                        dateStart.add(1,'month');
                    }
                    this.data.budgets = timeValues;
                }
            },
            getFmCode(search = '') {
                let request = {
                    filter: {
                        fm_code: { type: "text", value: search, function: 'ilike', with: [] },
                        gl_account_group: { type: "text", value: this.glAccountGroup, function: 'ilike', with: [] },
                    },
                    limit: -1,
                    page: 1,
                    isCMS: 1,
                    sortColumn: 'fm_code',
                    sortDirection: 'ASC',
                    contract_id: this.contract_id
                }
                this.$store.dispatch("FmCodeController/getFmCodeItems", request)
                .then(response => {
                    this.fmCodes = response.items;
                })
                .catch(err => {})
            },
            searchFmCode(search, loading) {
                this.fmCodes = []
                loading(true);
                if (this.timer.fmCode) {
                    clearTimeout(this.timer.fmCode);
                    this.timer.fmCode = null;
                }
                this.timer.fmCode = setTimeout(() => {
                    try {
                        this.getFmCode(search);
                        loading(false)
                    } catch (error) {
                        loading(false)
                    }
                }, 500);
            },
        }
    }
</script>